import PrivateRoute from '../../components/PrivateRoute'
import MaintenancePage from '../../pages/Manutenção/MaintenancePage'
import CreateMaintenancePage from '../../pages/Manutenção/CreateMaintenancePage'
import DetailsMaintenancePage from '../../pages/Manutenção/DetailsMaintenancePage'
import MaintenancesReport from '../../pages/Relatorios/Maintenances/Maintenances'
import WarrantiesPage from '../../pages/Manutenção/WarrantiesPage'
const RoutesManutencao = {
  maintenance: [
    {
      path: '/manutencao',
      element: <PrivateRoute element={MaintenancePage} />,
    },
    {
      path: '/manutencao/criar',
      element: <PrivateRoute element={CreateMaintenancePage} />,
    },
    {
      path: '/manutencao/detalhes/:id',
      element: <PrivateRoute element={DetailsMaintenancePage} />,
    },
    {
      path: '/manutencao/relatorios/manutencoes',
      element: <PrivateRoute element={MaintenancesReport} />,
    },
    {
      path: '/manutencao/garantias', // 🆕
      element: <PrivateRoute element={WarrantiesPage} />,
    },
  ],
}

export default RoutesManutencao
